export default __webpack_public_path__ + "static/media/boyz.c6c769d7.png";